import { ReactNode, useEffect, useState } from 'react';
import { getSession } from "next-auth/react";
import { Session } from "next-auth";
import { useRouter } from "next/router";

interface AccountLayoutProps {
    children: ReactNode;
}

export default function AccountLayout({ children }: AccountLayoutProps) {
    const router = useRouter();
    const [loading, setLoading] = useState(true);
    const [session, setSession] = useState<Session | null>(null);

    useEffect(() => {
        async function checkSession() {
            const sessionData = await getSession();
            if (!sessionData) {
                router.replace('/auth/accedi'); // Redirect se la sessione non esiste
            } else {
                setSession(sessionData);
                setLoading(false);
            }
        }

        checkSession();
    }, [router]);

    // Mentre la sessione viene caricata, mostra un loader o nulla
    if (loading) {
        return <div></div>; // Puoi sostituire con un loader migliore se preferisci
    }

    return (
        <div className="flex min-h-screen">
            <div className="flex-grow p-10 bg-gradient-to-br from-blue-50 to-indigo-50">
                {children}
            </div>
        </div>
    );
}
